import { render, staticRenderFns } from "./QccList.vue?vue&type=template&id=08b5d4b7&scoped=true"
import script from "./QccList.vue?vue&type=script&lang=js"
export * from "./QccList.vue?vue&type=script&lang=js"
import style0 from "./QccList.vue?vue&type=style&index=0&id=08b5d4b7&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5d4b7",
  null
  
)

export default component.exports